import React, { useState } from "react";
import { db, auth } from "../FirebaseConfig";
import { collection, addDoc } from "firebase/firestore";
import { toast } from "react-toastify";
import Header from "./Header";
import Footer from "./Footer";
import { useNavigate } from "react-router-dom";

const ProjectForm = () => {
  const [formData, setFormData] = useState({
    projectName: "",
    detailedRequirement: "",
    estimatedBudget: "",
    durationDays: "",
    durationMonths: "",
  });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    const user = auth.currentUser;
    if (!user) {
      toast.error("You must be logged in to submit a project.");
      setLoading(false);
      return;
    }

    const budget = parseInt(formData.estimatedBudget);
    if (budget < 1000 || budget > 5000000) {
      toast.error("Estimated Budget must be between 1,000 and 50,00,000 PKR.");
      setLoading(false);
      return;
    }

    try {
      await addDoc(collection(db, "projects"), {
        ...formData,
        email: user.email,
        status: "Submitted Request",
        paymentStatus: "Pending",
        createdAt: new Date(),
        feedback: "",
      });
      toast.success("Project submitted successfully!");
      navigate("/profile");
    } catch (error) {
      console.error("Error submitting project:", error);
      toast.error("Error submitting project.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Header />
      <div className="max-w-lg mx-auto p-6 my-12 bg-white shadow-lg rounded-lg">
        <h2 className="text-2xl font-semibold text-gray-800 mb-6 text-center">
          Start a New Project
        </h2>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Project Name
            </label>
            <input
              type="text"
              name="projectName"
              value={formData.projectName}
              onChange={handleChange}
              required
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Detailed Requirement
            </label>
            <textarea
              name="detailedRequirement"
              value={formData.detailedRequirement}
              onChange={handleChange}
              required
              rows="4"
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
            ></textarea>
          </div>
          <div>
            <label className="block text-sm font-medium text-gray-700">
              Estimated Budget (PKR)
            </label>
            <input
              type="number"
              name="estimatedBudget"
              value={formData.estimatedBudget}
              onChange={handleChange}
              required
              min="1000"
              max="5000000"
              className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
            />
            <p className="text-sm text-gray-500 mt-1">
              Range: 1,000 to 50,00,000 PKR
            </p>
          </div>
          <div className="flex space-x-4">
            <div className="w-1/2">
              <label className="block text-sm font-medium text-gray-700">
                Duration (Days)
              </label>
              <input
                type="number"
                name="durationDays"
                value={formData.durationDays}
                onChange={handleChange}
                min="0"
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>
            <div className="w-1/2">
              <label className="block text-sm font-medium text-gray-700">
                Duration (Months)
              </label>
              <input
                type="number"
                name="durationMonths"
                value={formData.durationMonths}
                onChange={handleChange}
                min="0"
                className="mt-1 block w-full p-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-orange-500"
              />
            </div>
          </div>
          <button
            type="submit"
            disabled={loading}
            className={`w-full py-2 px-4 rounded-md text-white font-medium ${
              loading
                ? "bg-gradient-to-r from-orange-500 to-red-500 cursor-not-allowed"
                : "bg-gradient-to-r from-orange-500 to-red-500"
            } flex items-center justify-center`}
          >
            {loading ? (
              <>
                <svg
                  className="animate-spin h-5 w-5 mr-2 text-white"
                  viewBox="0 0 24 24"
                >
                  <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                  ></circle>
                  <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"
                  ></path>
                </svg>
                Submitting...
              </>
            ) : (
              "Submit Project"
            )}
          </button>
        </form>
      </div>
      <Footer />
    </>
  );
};

export default ProjectForm;
